// extracted by mini-css-extract-plugin
export default {"root":"LoadingScreen_root__TCDrk"};